import { apiHost } from '../config';

const getApiUrl = path => apiHost + path;
export { getApiUrl };



// WEBPACK FOOTER //
// ./src/lib/apiUtil.js